import formClientConstants from './constants';

const formClientActions = {
  formClientInit: (formId, token) => ({
    type: formClientConstants.INITIALIZE_FORM_CLIENT,
    payload: {
      formId,
      token
    }
  }),
  formClientInitSuccess: form => ({
    type: formClientConstants.INITIALIZE_FORM_CLIENT_SUCCESS,
    payload: {
      form
    }
  }),
  formClientInitError: () => ({
    type: formClientConstants.INITIALIZE_FORM_CLIENT_ERROR
  }),
  formClientSubmit: (form, token) => ({
    type: formClientConstants.SUBMIT_FORM,
    payload: {
      form,
      token
    }
  }),
  formClientSubmitSuccess: () => ({
    type: formClientConstants.SUBMIT_FORM_SUCCESS
  }),
  formClientSubmitError: message => ({
    type: formClientConstants.SUBMIT_FORM_ERROR,
    payload: {
      message
    }
  })
};

export default formClientActions;
